import { render, staticRenderFns } from "./ParentConfigDialog.vue?vue&type=template&id=2c9be0b8&scoped=true"
import script from "./ParentConfigDialog.vue?vue&type=script&lang=js"
export * from "./ParentConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./ParentConfigDialog.vue?vue&type=style&index=0&id=2c9be0b8&prod&scoped=true&lang=css"
import style1 from "./ParentConfigDialog.vue?vue&type=style&index=1&id=2c9be0b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9be0b8",
  null
  
)

export default component.exports